// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__271P5","emails":"CreateEditClinics_emails__1yJM9","emailTagLabel":"CreateEditClinics_emailTagLabel__2di5k"};